import { useQuery, UseQueryResult } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Dayjs } from 'dayjs';
import {CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX} from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

type ImportType = {
    id: number,
    username: string,
    filename: string,
    status: number,
    rowNumbers: number,
    createdAt: string,
    lastEdit: string,
}[]

const useGetImports = (
    identifier: string,
    from: Dayjs | null,
    to: Dayjs | null,
): UseQueryResult<ApiResponse<ImportType>, ApiError<ImportType>> => {
    const navigate = useNavigate();

    const queryParams = new URLSearchParams();
    appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
    appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<ApiResponse<ImportType>, ApiError<ImportType>>(
        [`ad_imports_${queryKey}`],
        () => dataFetch.get(`${DIGGER_API_SUFFIX}internal/imports?${queryParams}`),
        {
            onSuccess: () => {
                navigate(`${window.location.pathname}?${queryParams.toString()}`, { replace: true });
            },
        },
    );
};

export default useGetImports;
